<template>
	<div>
		<div class="filter-inline-panel cle">
		<el-form :inline="true" size="mini" :model="pages" class="filter-panel">
			<el-form-item :label="$t('order.date_time')" prop="date">
				<el-date-picker v-model="pages.date" type="daterange" :range-separator="$t('course_index.range')" value-format="timestamp" :start-placeholder="$t('course_index.starttime')" :end-placeholder="$t('course_index.endtime')"></el-date-picker>
			</el-form-item>
			<!-- <el-form-item :label="$t('order.email')" prop="email" data-name="email">
				<el-input v-model="pages.email" :placeholder="$t('index.pleaseInput')"></el-input>
			</el-form-item> -->
			<el-form-item :label="$t('order.tel')" prop="tel" data-name="tel">
				<el-input v-model="pages.tel" :placeholder="$t('index.pleaseInput')"></el-input>
			</el-form-item>
			<el-form-item :label="$t('order.name')" prop="name" data-name="主题">
				<el-input v-model="pages.course_name" :placeholder="$t('index.pleaseInput')"></el-input>
			</el-form-item>
			<el-form-item :label="$t('order.course_date_time')" prop="date">
				<el-date-picker v-model="pages.date_time" type="daterange" :range-separator="$t('course_index.range')" value-format="timestamp" :start-placeholder="$t('course_index.starttime')" :end-placeholder="$t('course_index.endtime')"></el-date-picker>
			</el-form-item>
			<!-- <el-form-item :label="$t('order.referred_email')" prop="referred_email" data-name="推荐人邮箱">
				<el-input v-model="pages.referred_email" :placeholder="$t('index.pleaseInput')"></el-input>
			</el-form-item> -->
			<el-form-item :label="$t('order.no')" prop="no" data-name="no">
				<el-input v-model="pages.id" :placeholder="$t('index.pleaseInput')"></el-input>
			</el-form-item>
			<el-form-item :label="$t('order.customer_name')" prop="name" data-name="name">
				<el-input v-model="pages.name" :placeholder="$t('index.pleaseInput')"></el-input>
			</el-form-item>
			<el-form-item :label="$t('order.payment')" prop="name" data-name="name">
				<el-select v-model="pages.pay_method" placeholder="请选择">
					<el-option v-for="(item,index) in PAYMENT" :key="index" :label="lang=='cn'?item.name_cn:item.name" :value="item.code"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item :label="$t('index.seller')" prop="name" data-name="name">
				<el-select v-model="pages.seller_id" placeholder="请选择" class="w100">
					<el-option v-for="(item,index) in sellerList" :key="index" :label="item.name" :value="item.id"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item :label="$t('order.notes')" prop="remarks" data-name="remarks">
				<el-input v-model="pages.remarks" :placeholder="$t('index.pleaseInput')"></el-input>
			</el-form-item>
			<!-- <el-form-item data-name="first">
					<el-checkbox v-model="pages.first" :true-label="1" :false-label="0">{{$t('order.first')}}</el-checkbox>
				</el-form-item>
			<el-form-item> -->
				<el-button type="primary" size="mini" @click="handleCurrentChange(1)">{{$t('index.search')}}</el-button>
				<el-button type="primary" size="mini" @click="reset(1)">{{$t('index.reset')}}</el-button>
			</el-form-item>
		</el-form>
			<div class="list-opinion fr">
				<el-button type="primary" size="mini" v-if="hasBtn('export')" @click="orderExport">{{$t('index.export')}}</el-button>
			</div>
		</div>
		<el-table :data="list" border size="mini">
			<el-table-column prop="order_id" align="center" :label="$t('order.no')"></el-table-column>
			<el-table-column align="center" :label="$t('order.name')" data-name="主题">
				<template slot-scope="{row}">{{lang=='cn'?row.title_cn:row.title}}</template>
			</el-table-column>
			<el-table-column prop="create_time" align="center" :label="$t('order.create_time')">
				<template slot-scope="{row}">{{getTime_us(row.create_time,'mmddyyyy')}}   {{getTime_us(row.create_time,'hh:ii')}}</template>
			</el-table-column>
			<el-table-column prop="user_info.name" align="center" :label="$t('order.customer_name')" data-name="客户名称"></el-table-column>
			<el-table-column prop="user_info.wechat_id" align="center" :label="$t('student_list.wechat')" data-name="微信号"></el-table-column>
			<el-table-column prop="children_name" align="center" :label="$t('order.children')" data-name="学生">
				<template slot-scope="{row}">
					<div v-for="(item,index) in row.camp_arr" :key="index">
						<div v-for="(items,indexs) in item.children" :key="indexs">{{items.name}}<br/> （{{items.age>50?'成人':items.age+'岁'}}）</div>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="user_info.tel" align="center" :label="$t('order.tel')" data-name="tel"></el-table-column>

			<el-table-column prop="price" align="center" :label="$t('order.price')"></el-table-column>
			<!-- <el-table-column prop="use_score" align="center" :label="$t('order.score')"></el-table-column> -->
			<el-table-column prop="discount" align="center" :label="$t('order.discount')">
				<template slot-scope="{row}">{{amount_jisuan(row)}}</template>
			</el-table-column>
			<el-table-column prop="refund_amount" align="center" :label="$t('order.refund')">
				<template slot-scope="{row}">
					<div :style="'color:'+(row.refund_amount>0?'#ff0000':'#333333')">{{row.refund_amount}}</div>
				</template>
			</el-table-column>
			<el-table-column prop="pay_price" align="center" :label="$t('order.total')"></el-table-column>
			<!-- <el-table-column prop="pay_method" align="center" :label="$t('order.实际营收')"> -->
				<!-- <template slot-scope="{row}">{{(row.pay_price-row.refund_amount).toFixed(2)}}</template> -->
			<!-- </el-table-column> -->
			<el-table-column prop="pay_method" align="center" :label="$t('order.payment')"></el-table-column>
			<!-- <el-table-column prop="seller_name" align="center" :label="$t('parent_index.seller')"></el-table-column> -->
			<el-table-column prop="remarks" align="center" :label="$t('feedback_index.remarks')"></el-table-column>
			<el-table-column prop="confirmation" align="center" :label="$t('order.letter')">
				<template slot-scope="{row}">{{row.confirmation==1?'YES':'NO'}}</template>
			</el-table-column>
			<el-table-column prop="first" align="center" :label="$t('order.first')">
				<template slot-scope="{row}">{{row.first==1?'YES':'NO'}}</template>
			</el-table-column>
			<el-table-column prop="classes" align="center" :label="$t('index.operation')" width="200" fixed="right">
				<template slot-scope="{row}">
					<!-- <el-button type="primary" size="mini" data-name="详情" @click="router('/order_info',{id: row.order_id })">{{$t('index.info')}}</el-button> -->
					<el-button type="primary" size="mini" data-name="详情" @click="order_id = row.order_id,infoVisible=true">{{$t('index.info')}}</el-button>
					<el-button type="primary" size="mini" data-name="重发确认信" v-if="hasBtn('resend')" @click="sendConfirmation(row)">{{$t('index.resend')}}</el-button>
					<p class="ma_top">
						<el-button type="primary" size="mini" data-name="备注" @click="remarks_ff(row)">{{$t('feedback_index.remarks')}}</el-button>
						<el-button type="primary" size="mini" data-name="绑定销售" v-if="hasBtn('seller')" @click="binding_seller(row)">{{$t('index.seller')}}</el-button>
					</p>
					<p class="ma_top">
						<el-button type="danger" size="mini" data-name="取消订单" v-if="hasBtn('cancel')&&row.status>=2&&row.status!=9" @click="click_cancel(row)">{{$t('index.cancel')}}</el-button>
					</p>
				</template>
			</el-table-column>
		</el-table>
		<div class="page-pagination">
			<el-pagination align="right" small background :hide-on-single-page="false" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pages.page" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="pages.perpage" layout="total, prev, pager, next, sizes, jumper" :total="pages.count" :pager-count="5"></el-pagination>
		</div>
		<el-dialog :title="$t('index.seller')" width="500px" :close-on-click-modal="false" :visible="seller_is" @close="seller_is = false">
			<el-form :model="seller_form" ref="seller_form" size="mini" label-width="80px" label-position="top">
				<el-row :gutter="20">
					<el-col :span="24">
						<el-form-item :label="$t('index.seller')" data-name="订单号">
							<el-select v-model="seller_form.seller_id" placeholder="请选择" class="w100">
								<el-option v-for="(item,index) in sellerList" :key="index" :label="item.name" :value="item.id"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
			</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="mini" @click.native="seller_is = false">{{$t('index.cancel')}}</el-button>
				<el-button type="primary" size="mini" @click="seller_f()">{{$t('index.submit')}}</el-button>
			</div>
		</el-dialog>
		<el-dialog :title="$t('index.dialog_title')" width="1200px" :close-on-click-modal="false" :visible="editFormVisible" @close="editFormVisible = false">
			<el-form :model="order_info" size="mini" label-width="80px" label-position="top">
				<el-row class="tree-content" :gutter="20">
					<el-col :span="8">
						<el-form-item :label="$t('order.no')" data-name="订单号">
							<div class="el-form-item__content">
								<div class="w100 el-input el-input--mini"><div class="el-input__inner">{{order_info.order_id}}</div></div>
							</div>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item :label="$t('order.create_time')" data-name="购买时间">
							<div class="el-form-item__content">
								<div class="w100 el-input el-input--mini"><div class="el-input__inner">{{getTime_us(order_info.create_time,'mmddyyyy')}}{{getTime_us(order_info.create_time,'hh:ii')}}</div></div>
							</div>
						</el-form-item>
					</el-col>
					<!-- <el-col :span="8">
						<el-form-item :label="$t('order.total')" data-name="支付金额">
							<div class="el-form-item__content">
								<div class="w100 el-input el-input--mini"><div class="el-input__inner">{{order_info.pay_price}}</div></div>
							</div>
						</el-form-item>
					</el-col> -->
					<el-col :span="8">
						<el-form-item :label="$t('order.customer_name')" data-name="客户名称">
							<div class="el-form-item__content">
								<div class="w100 el-input el-input--mini"><div class="el-input__inner">{{order_info.user_info.name}}</div></div>
							</div>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item :label="$t('order.email')" data-name="email">
							<div class="el-form-item__content">
								<div class="w100 el-input el-input--mini"><div class="el-input__inner">{{order_info.user_info.email}}</div></div>
							</div>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item :label="$t('order.price')" data-name="price">
							<div class="el-form-item__content">
								<div class="w100 el-input el-input--mini"><div class="el-input__inner">{{order_info.price}}</div></div>
							</div>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item :label="$t('order.discount')" data-name="discount">
							<div class="el-form-item__content">
								<div class="w100 el-input el-input--mini"><div class="el-input__inner">{{amount_jisuan(order_info)}}</div></div>
							</div>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item :label="$t('order.total')" data-name="total">
							<div class="el-form-item__content">
								<div class="w100 el-input el-input--mini"><div class="el-input__inner">{{order_info.pay_price}}</div></div>
							</div>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item :label="$t('order.refund')" data-name="refund">
							<div class="el-form-item__content">
								<div class="w100 el-input el-input--mini"><div class="el-input__inner">{{order_info.refund_amount}}</div></div>
							</div>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item :label="$t('order.payment')" data-name="payment">
							<div class="el-form-item__content">
								<div class="w100 el-input el-input--mini"><div class="el-input__inner">{{order_info.pay_method}}</div></div>
							</div>
						</el-form-item>
					</el-col>
				</el-row>
				<div v-if="course_list.length">
					<div class="pp1">{{$t('order.classes_name')}}</div>
						<el-table :data="course_list" border size="mini">
					<el-table-column prop="order_id" align="center" :label="$t('order.no')">
						<template slot-scope="{row}">{{row.order_id}}</template>
					</el-table-column>
					<el-table-column prop="create_time" align="center" :label="$t('order.create_time')">
					<template slot-scope="{row}">{{getTime_us(row.create_time,'mmddyyyy')}}   {{getTime_us(row.create_time,'hh:ii')}}</template>
					</el-table-column>
					<el-table-column  align="center" :label="$t('order.name')">
					<template slot-scope="{row}">
						<a target="_blank" class="clo3" :href="API_URL+'#/course_info?id='+row.course_id">{{lang=='cn'?row.name_cn:row.name}}</a>
					</template>
					</el-table-column>
					<el-table-column prop="children_name" align="center" :label="$t('order.children')">
						<template slot-scope="{row}">
					<span v-for="(item,index) in row.children" :key="index">{{item.name}}{{item.age}}y</span>
						</template>
					</el-table-column>
					<el-table-column :prop="lang=='cn'?'teacher.name_cn':'teacher.name'" align="center" :label="$t('order.teacher')"></el-table-column>
					<el-table-column align="center" :label="$t('order.date')">
						<template slot-scope="{row}">{{getTime_us(row.course_info.start_date,'mmddyyyy')}}-{{getTime_us(row.course_info.end_date,'mmddyyyy')}}</template>
					</el-table-column>
					<el-table-column align="center" :label="$t('order.time')">
						<template slot-scope="{row}">{{getTime_us(row.course_info.start_time,'hh:ii')}}-{{getTime_us(row.course_info.end_time,'hh:ii')}}</template>
					</el-table-column>
					<el-table-column align="center" :label="$t('order.on_date')">
						<template slot-scope="{row}">
							{{row.course_info.no_course_dates | no_course_dates_f(this_)}}
						</template>
					</el-table-column>
					<el-table-column prop="course_info.price" :label="$t('order.price')" align="center" :key="10"></el-table-column>
					<el-table-column align="center" :label="$t('index.operation')" data="操作" :key="11">
						<template slot-scope="{row}">
							<el-button type="primary" size="mini" class="tag-read" @click="copy" :data-clipboard-text="geshihua(row)">{{$t('index.copy')}}</el-button>
						</template>
					</el-table-column>
				</el-table>
				</div>
				<div v-if="camp_list.length">
					<div class="pp1">{{$t('order.camps')}}</div>
						<el-table :data="camp_list" border size="mini">
					<el-table-column prop="transaction_id" align="center" :label="$t('order.no')">
					<template slot-scope="{row}">{{row.transaction_id}}</template>
					</el-table-column>
					<el-table-column prop="create_time" align="center" :label="$t('order.create_time')">
					<template slot-scope="{row}">{{getTime_us(row.create_time,'mmddyyyy')}}   {{getTime_us(row.create_time,'hh:ii')}}</template>
					</el-table-column>
					<el-table-column align="center" :label="$t('order.subject')">
					<template slot-scope="{row}">
							<a target="_blank" class="clo3" :href="API_URL+'#/course_camps_info?id='+row.camp_id">{{lang=='cn'?row.theme_cn:row.theme}}</a>
					</template>
					</el-table-column>
					<el-table-column prop="children_name" align="center" :label="$t('order.children')">
						<template slot-scope="{row}">
					<span v-for="(items,indexs) in row.children" :key="indexs">{{items.name}}{{items.age}}y</span>
						</template>
					</el-table-column>
					<el-table-column :prop="lang=='cn'?'teacher_name_cn':'teacher_name'" align="center" :label="$t('order.teacher')"></el-table-column>
					<el-table-column align="center" :label="$t('order.date')">
						<template slot-scope="{row}">{{getTime_us(row.start_date_time,'mmddyyyy')}}-{{getTime_us(row.end_date_time,'mmddyyyy')}}</template>
					</el-table-column>
					<el-table-column align="center" :label="$t('order.time')">
						<template slot-scope="{row}">{{getTime_us(row.start_time,'hh:ii')}}-{{getTime_us(row.end_time,'hh:ii')}}</template>
					</el-table-column>
					<el-table-column align="center" :label="$t('order.on_date')">
						<template slot-scope="{row}">{{row.no_course_date | no_course_dates_f(this_)}}</template>
					</el-table-column>
					<el-table-column align="center" :label="$t('index.operation')" data="操作">
						<template slot-scope="{row}">
							<el-button type="primary" size="mini" class="tag-read" @click="copy" :data-clipboard-text="geshihua_xalingy(row)">{{$t('index.copy')}}</el-button>
						</template>
					</el-table-column>
				</el-table>
				</div>
				<div v-if="refund_list.length">
			<div class="pp1">{{$t('order.refund_name')}}</div>
			<el-table :data="refund_list" border size="mini">
				<el-table-column prop="order_id" align="center" label="ID"></el-table-column>
				<el-table-column prop="pay_method" align="center" :label="$t('order.payment')"></el-table-column>
				<el-table-column prop="price" align="center" :label="$t('order.refund')"></el-table-column>
				<el-table-column prop="user_name" align="center" :label="$t('journal.user_name')"></el-table-column>
				<el-table-column prop="create_time" align="center" :label="$t('journal.create_time')">
					<template slot-scope="{row}">{{getTime_us(row.create_time,'mmddyyyy')}}</template>
				</el-table-column>
				<el-table-column prop="action" align="center" :label="$t('index.operation')"></el-table-column>
				<el-table-column prop="remarks" align="center" :label="$t('order.notes')"></el-table-column>
			</el-table>
				</div>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="mini" @click.native="editFormVisible = false">{{$t('index.cancel')}}</el-button>
				<el-button type="primary" size="mini" @click="refund(order_info)">{{$t('index.refund')}}</el-button>
				<!-- <el-button size="mini" type="primary" @click.native="editSubmit('editForm')">{{$t('index.submit')}}</el-button> -->
			</div>
			<el-dialog :title="$t('order.refund_title')" width="500px" :close-on-click-modal="false" :visible="refund_is" @close="refund_is = false" append-to-body>
				<el-form :model="order_info" size="mini" label-width="80px" label-position="top">
						<el-row class="tree-content" :gutter="20">
							<el-col :span="12">
								<el-form-item :label="$t('order.total')" data-name="支付金额">
									<div class="el-form-item__content">
										<div class="w100 el-input el-input--mini"><div class="el-input__inner">{{order_info.pay_price}}</div></div>
									</div>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item :label="$t('order.refund')" data-name="退款金额">
									<el-input-number v-model="filterForm.refund_amount" :precision="2" :min="0" :max="tuikuanjine(order_info)"></el-input-number>
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item :label="$t('order.notes')" data-name="备注">
									<el-input type="textarea" :autosize="{ minRows: 6, maxRows: 6}" :placeholder="$t('index.pleaseInput')" v-model="filterForm.notes"></el-input>
								</el-form-item>
							</el-col>
					</el-row>
			</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button size="mini" @click.native="refund_is = false">{{$t('index.cancel')}}</el-button>
					<el-button size="mini" type="primary" @click.native="refund_f('editForm')">{{$t('index.submit')}}</el-button>
				</div>
			</el-dialog>
		</el-dialog>
		<el-dialog :title="$t('feedback_index.remarks')" width="800px" :close-on-click-modal="false" :visible="editFormVisible1" @close="editFormVisible1 = false">
			<el-form :model="editForm" size="mini" label-width="80px" label-position="top" :rules="editFormRules" ref="editForm1">
				<el-row :gutter="20">
					<el-col :span="24">
						<el-form-item :label="$t('feedback_index.remarks')" prop="remarks">
							<el-input v-model="editForm.remarks" type="textarea" :autosize="{ minRows: 4, maxRows: 6}" class="w100" :placeholder="$t('index.pleaseInput')" auto-complete="off"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="mini" @click.native="editFormVisible1 = false">{{$t('index.cancel')}}</el-button>
				<el-button size="mini" type="primary" @click.native="editSubmit1('editForm1')">{{$t('index.submit')}}</el-button>
			</div>
		</el-dialog>
		<el-dialog :title="$t('index.info')" width="1400px" :close-on-click-modal="false" :visible="infoVisible" @close="infoVisible = false">
			<info v-if="infoVisible" :order_id="order_id"></info>
		</el-dialog>
	</div>
</template>
<script>
import Clipboard from 'clipboard';
import info from './components/info.vue'
export default {
	computed: {
		editFormRules() {
			return {
				remarks: [{
					required: true,
					message: this.$t('index.pleaseInput') + this.$t('feedback_index.remarks'),
					trigger: 'blur'
				}],
			}
		}
	},
	components: {
		info,
	},
	data() {
		return {
			this_:this,
			list: [],
			id: '',
			pages: {
			},
			editFormVisible:false,
			order_info:{
				user_info:{},
			},
			course_list:[],
			camp_list:[],
			API_URL:process.env.API_URL,
			filterForm:{
				refund_amount:'',
				order_id:'',
				notes:'',
			},
			refund_is:false,
			refund_list:[],
			PAYMENT:[],
			payment:[
				{
					name:'Credit Card (Stripe)',
					id:'2'
				},
				{
					name:'PayPal',
					id:'1'
				}
			],
			sellerList:[],
			seller_is:false,
			seller_form:{},
			editFormVisible1:false,
			editForm:{
				id:'',
				remarks:'',
			},
			infoVisible:false,
			order_id:'',
		}
	},
	// 初始事件
	mounted: function () {
		this.getSchoolWebModuleMessageListFunc();
		this.config();
		this.init();
	},
	destroyed(){
		sessionStorage.removeItem("order_info");
	},
	// 事件
	methods: {
		getSchoolWebModuleMessageListFunc(){
			if(sessionStorage.getItem('order_info')){
				this.pages=JSON.parse(sessionStorage.getItem('order_index'));
			}else{
				this.pages={
					page: 1,
					count: 0,
					perpage: 10,
					email:'',
					name:'',
					id:'',
					pay_method:'',
					referred_email:'',
					course_name:'',
					date:[],
					date_time:[],
					tel:'',
					remarks:'',
				}
				sessionStorage.removeItem("order_info");
			}
		},
		config(){
			this.$post('sellerListNoPage',{seller_type:'seller'}).then((res) => {
				this.sellerList=res;
			})
			this.$post('getDictionaryValue',{code:"PAYMENT"}).then((res) => {
				this.PAYMENT = res.PAYMENT;
			})
		},
		// 初始化
		init() {
			var this_ = this;
			var url = "orderListAll";
			var datas = {
				page:this_.pages.page,
				num:this_.pages.perpage,
				email:this_.pages.email,
				order_id:this_.pages.id,
				remarks:this_.pages.remarks,
				name:this_.pages.name,
				pay_method:this_.pages.pay_method,
				referred_email:this_.pages.referred_email,
				tel:this_.pages.tel,
				course_name:this_.pages.course_name || '',
				seller_id:this_.pages.seller_id || '',
			};
			if (this_.pages.date&&this_.pages.date.length>0) {
				datas['start_time']=this_.pages.date[0]/1000;
				datas['end_time']=this_.pages.date[1]/1000;
			}
			if (this_.pages.date_time&&this_.pages.date_time.length>0) {
				datas['course_start_time']=this_.pages.date_time[0]/1000;
				datas['course_end_time']=this_.pages.date_time[1]/1000;
			}
			this_.$post(url, datas).then((res) => {
				sessionStorage.setItem('order_index',JSON.stringify(this_.pages));
				this_.list = res.list;
				this_.pages.count = res.sum;
			})
		},
		info(data){
			var this_ = this;
			var url = "orderInfo";
			var datas = {
				order_id:data.order_id,
			};
			this_.$post(url, datas).then((res) => {
				this_.camp_list = res.camp_list||{};
				this_.course_list = res.course_list||[];
				this_.order_info = JSON.parse(JSON.stringify(data));
				this_.editFormVisible=true;
			})
			var url = "adminRefundRecord";
			var datas = {
				page:1,
				num: 1000,
				order_id:data.order_id
			};
			this_.$post(url, datas).then((res) => {
				this_.refund_list = res.list;
			})
		},
		orderExport(){
			var TokenId = sessionStorage.getItem('TokenId');
			var lang  = localStorage.getItem('lang')!='cn'?'us':'cn';
			var url =  process.env.API_ROOT+'orderExport?TokenId='+TokenId+'&language='+lang;
			var pages=this.pages;
			if (pages.email) {
				url+='&email='+pages.email;
			}
			if (pages.name) {
				url+='&name='+pages.name;
			}
			if (pages.id) {
				url+='&order_id='+pages.id;
			}
			if (pages.remarks) {
				url+='&remarks='+pages.remarks;
			}
			if (pages.pay_method) {
				url+='&pay_method='+pages.pay_method;
			}
			if (pages.referred_email) {
				url+='&referred_email='+pages.referred_email;
			}
			if (pages.tel) {
				url+='&tel='+pages.tel;
			}
			if (pages.course_name) {
				url+='&course_name='+pages.course_name;
			}
			if (pages.seller_id) {
				url+='&seller_id='+pages.seller_id;
			}
			if (pages.date&&pages.date.length>0) {
				url+='&start_time='+(pages.date[0]/1000)+'&end_time='+(pages.date[1]/1000);
			}
			if (pages.date_time&&pages.date_time.length>0) {
				url+='&course_start_time='+(pages.date_time[0]/1000)+'&course_end_time='+(pages.date_time[1]/1000);
			}
			console.log(url)
			window.open(url);
		},
		// 分页每页显示几条
		handleSizeChange(val) {
			var pages = this.pages;
			pages['perpage'] = val;
			this.pages = pages;
			this.init();
		},
		// 切换分页
		handleCurrentChange(val) {
			var pages = this.pages;
			pages['page'] = val;
			this.pages = pages;
			this.init();
		},
		reset(){
			this.pages.seller_id='';
			this.pages.email='';
			this.pages.pay_method='';
			this.pages.id='';
			this.pages.notes='';
			this.pages.name='';
			this.pages.course_name='';
			this.pages.tel='';
			this.pages.date=[];
			this.handleCurrentChange(1);
		},
		// 优惠金额
		amount_jisuan(data){
			var discounts=data.discounts?parseFloat(data.discounts):0;
			var coupon_price=data.coupon_price?parseFloat(data.coupon_price):0; 
			var yaoqing_price=data.yaoqing_price?parseFloat(data.yaoqing_price):0;
			var zhekou=data.zhekou?parseFloat(data.zhekou):0;
			// var use_score=data.use_score?parseFloat(data.use_score):0;
			var zhi= discounts+coupon_price+yaoqing_price+zhekou;
			return zhi.toFixed(2);
		},
		// 退款
		refund(data){
			var this_ = this;
			this_.filterForm.order_id=data.order_id;
			this_.filterForm.pay_price=data.pay_price;
			this_.refund_is=true;
		},
		refund_f(){
			var this_ = this;
			var url = "refundOrder";
			var datas = {
				order_id:this_.order_info.order_id,
				refund_amount:this_.filterForm.refund_amount,
				remarks:this_.filterForm.notes,
			};
			this_.$confirm(this_.$t('order.confirm_delete'), this_.$t('index.tips')).then(() => {
				this_.$post(url, datas).then((res) => {
					this_.$message.success(this_.$t('index.operation_success'));
					this_.refund_is=false;
					this_.init();
				})
			}).catch(() => {});
		},
		tuikuanjine(data){
			var pay_price=data.pay_price;
			var refund_amount=data.refund_amount;
			var max=parseFloat(pay_price)-parseFloat(refund_amount);
			return max
		},
		// 复制
		copy(){
			var this_ = this;
			var clipboard = new Clipboard('.tag-read');
			clipboard.on('success', e => {
				this_.$message.success(this_.$t('index.copy_success'));
				clipboard.destroy()
			})
			clipboard.on('error', e => {
				this_.$message.success(this_.$t('index.copy_error'));
				clipboard.destroy()
			})
		},
		// 绑定销售
		binding_seller(data){
			this.seller_form.order_id=JSON.parse(JSON.stringify(data)).order_id;
			this.seller_is=true;
		},
		// 确定绑定
		seller_f(){
			var this_ = this;
			this_.$refs.seller_form.validate((valid) => {
				if (valid) {
					var datas = {
						order_id: this_.seller_form.order_id,
						seller_id: this_.seller_form.seller_id,
					}
					var url = "changeOrderSeller";
					this_.$post(url, datas).then((res) => {
						this_.$message.success(this_.$t('index.operation_success'));
						this_.seller_is = false;
						this_.init();
					});
				} else {
					return false;
				}
			})
		},
		router(url,query){
			this.$router.push({path:url,query:query})
		},
		geshihua(data){
			var name="#"+data.order_id+' '+(this.getTime_us(data.course_info.start_date,'mmdd'))+'-'+(this.getTime_us(data.course_info.end_date,'mmdd'))+','+(this.getTime_us(data.course_info.start_time,'ampm'))+'-'+(this.getTime_us(data.course_info.end_time,'ampm'))+','+(this.lang=='cn'?data.teacher.name_cn:data.teacher.name)+','+(this.lang=='cn'?data.name_cn:data.name);
			return name;
		},
		geshihua_xalingy(data,camp_list){
			var name="#"+data.transaction_id+' '+(this.getTime_us(data.start_date_time,'mmdd'))+'-'+(this.getTime_us(data.end_date_time,'mmdd'))+','+(this.getTime_us(data.start_time,'ampm'))+'-'+(this.getTime_us(data.end_time,'ampm'))+','+(this.lang=='cn'?data.teacher_name_cn:data.teacher_name)+','+(this.lang=='cn'?data.theme_cn:data.theme);
			return name;
		},
		// 重发确认信
		sendConfirmation(data){
			var this_ = this;
			var url = "sendConfirmation";
			var datas = {
				order_id:data.order_id
			};
			this_.$confirm(this_.$t('order.sendconfirmation'), this_.$t('index.tips')).then(() => {
				this_.$post(url, datas).then((res) => {
					this_.$message.success(this_.$t('index.operation_success'));
					this_.init();
				})
			})
		},
		remarks_ff(data){
			this.editForm.id=data.order_id;
			this.editForm.remarks=data.remarks;
			this.editFormVisible1=true;
		},
		editSubmit1(editForm){
			var this_ = this;
			this_.$refs[editForm].validate((valid) => {
				if (valid) {
					var datas = {
						table: 'order_db',
						field: 'remarks',
						value: this_.editForm.remarks,
						pk_id: this_.editForm.id,
					}
					var url = "changeField";
					this_.$post(url, datas).then((res) => {
						this_.$message.success(this_.$t('index.add_success'));
						this_.editFormVisible1 = false;
						this_.init();
					});
				} else {
					return false;
				}
			})
		},
		// 取消
		click_cancel(data){
			this.$prompt(this.$t('index.confirm_cancel'), this.$t('index.tips'), {
				inputPlaceholder:'备注',
				inputType:'textarea'
			}).then(({ value }) => {
				this.$post('order/cancelorder',{order_id: data.order_id, remarks:value||''}).then((res) => {
					this.$message.success(this.$t('index.operation_success'));
					this.init();
				})
			}).catch(() => {});
		}
	},
	// 过滤器
	filters: {
		no_course_dates_f(v,this_){
			var array=v.split(',');
			var zhi=[];
			array.forEach(function(e,i) {
				if (e) {
					zhi[i]=this_.getTime_us(e,'mmddyyyy');
				}
			});
			return zhi.join(',');
		},
	}
}
</script>
<style scoped>
.transaction_id{
	color: #ff0000;
}
.pp1{
	text-align: center;
	line-height: 40px;
	margin-top: 10px;
}
.clo3{
	color: #ff0000;
}
.filter-panel{
	width: calc( 100% - 70px ); 
	float: left;
}
.ma_top{
	margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/order/index.vue